import LxpLayout from "@/views/layout/lxp/LxpLayout";
import navigationUtils from "@/assets/js/navigationUtils";
import LxpMobileLayout from "@/views/layout/lxp/mobile/LxpMobileLayout";
const isMobile = navigationUtils.any();

const instructorRoutes = [
  {
    path: '/instructor',
    component: isMobile ? LxpMobileLayout : LxpLayout,
    children: [
      {
        path: '',
        name: "InstructorCard",
        component: () => isMobile ? import('../../views/pages/instructor/mobile/MobileInstructorCard'): import('../../views/pages/instructor/InstructorCard')
      }
    ],
  }
];

export const setInstructorRoutes = (routes) => {
  routes.push(...instructorRoutes);
}